// src/app/telemetry-config.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export type Provider = 'aws' | 'azure' | 'none';

export interface TelemetryJson {
    provider: Provider;
    aws?: any;
    azure?: any;
}

@Injectable({ providedIn: 'root' })
export class TelemetryConfigService {
    private _config: TelemetryJson = { provider: 'none' }
    get config() { return this._config; }

    constructor(private http: HttpClient) { }

    //   load(): Promise<void> {
    //     return this.http.get<TelemetryJson>('/assets/config.json', { withCredentials: false })
    //       .toPromise()
    //       .then(cfg => { this._config = cfg!; });
    //   }

    load(): Promise<void> {
        return fetch('/assets/config.json')
            .then(res => res.json())
            .then(data => {
                this._config = data!;
            });
    }
}